import React, { useEffect, useState } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom';
import { ENUM_QUERY_PARAMS } from './utils/Enumerados';
import { useAuthServices } from './services/useFetch';
import { Card, CardBody, Row, Col, Button, Container, Spinner, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarCheck, faClock, faUser, faPhone, faEnvelope, faInfoCircle, faUserTie, faBan, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import './AgendateInfoCita.css';

const AgendateInfoCita = () => {

    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { requestPost } = useAuthServices();

    const [citaData, setCitaData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [cancelModal, setCancelModal] = useState(false);
    const [cancelando, setCancelando] = useState(false);
    const [cancelSuccess, setCancelSuccess] = useState(false);

    useEffect(() => {
        if (searchParams.has(ENUM_QUERY_PARAMS.ID_CITA_INFO)) {
            const idCita = searchParams.get(ENUM_QUERY_PARAMS.ID_CITA_INFO);
            obtieneDetalleCitaService(idCita);
        } else {
            setLoading(false);
        }
    }, [searchParams])

    const obtieneDetalleCitaService = async (idCita) => {
        setLoading(true);
        const body = { idCita };
        const response = await requestPost(body, 23);
        if (!response.error) {
            const { estado, objeto } = response.data
            if (estado && objeto) {
                setCitaData(objeto);
            }
        } else {
            console.error("Error al obtener detalle de cita: ", response.error);
        }
        setLoading(false);
    }

    const toggleCancelModal = () => setCancelModal(!cancelModal);

    const handleCancelarCita = async () => {
        if (!citaData) return;
        setCancelando(true);
        const body = { idCita: citaData.id };
        const response = await requestPost(body, 24);
        if (!response.error) {
            const { estado } = response.data;
            if (estado) {
                setCancelSuccess(true);
                setCitaData({ ...citaData, estado: 'CANCELADA' });
            }
        }
        setCancelando(false);
        toggleCancelModal();
    }

    if (loading) {
        return (
            <div className="info-cita-loader">
                <Spinner color="warning" style={{ width: '4rem', height: '4rem' }} />
                <h4 className="mt-4">Cargando información de tu cita...</h4>
            </div>
        )
    }

    if (!citaData) {
        return (
            <div className="info-cita-loader">
                <FontAwesomeIcon icon={faBan} size="4x" color="#ccc" />
                <h4 className="mt-4">No se encontró la información de la cita.</h4>
                <Button className="bottom-custom-secondary mt-3" onClick={() => navigate('/')}>Ir al Inicio</Button>
            </div>
        )
    }

    const isCancelada = citaData.estado === 'CANCELADA';

    return (
        <div className="info-cita-container">
            <Container className="py-5">
                <Row className="justify-content-center">
                    <Col md="10" lg="8" xl="6">
                        <Card className={`info-cita-card ${isCancelada ? 'cancelada' : ''}`}>
                            <div className="card-header-custom">
                                <div className="icon-wrapper">
                                    <FontAwesomeIcon icon={isCancelada ? faBan : faCalendarCheck} className="header-icon" />
                                </div>
                                <h2>Detalle de tu Cita</h2>
                                <span className={`badge-estado ${isCancelada ? 'bg-danger' : 'bg-success'}`}>
                                    {isCancelada ? 'Cancelada' : citaData.estado || 'Confirmada'}
                                </span>
                            </div>
                            <CardBody className="p-1">
                                {cancelSuccess && (
                                    <div className="alert alert-success d-flex align-items-center mb-4" role="alert">
                                        <FontAwesomeIcon icon={faCheckCircle} className="me-3 fs-4" />
                                        <div>Tu cita ha sido cancelada exitosamente.</div>
                                    </div>
                                )}
                                <div className="info-section mt-2">
                                    <div className="info-item mx-2">
                                        <div className="info-icon"><FontAwesomeIcon icon={faUser} /></div>
                                        <div className="info-content">
                                            <small>Paciente / Cliente</small>
                                            <p>{citaData.cliente}</p>
                                        </div>
                                    </div>
                                    <div className="info-item mx-2">
                                        <div className="info-icon"><FontAwesomeIcon icon={faUserTie} /></div>
                                        <div className="info-content">
                                            <small>Profesional Asignado</small>
                                            <p>{citaData.usuario}</p>
                                        </div>
                                    </div>
                                    <div className="info-row">
                                        <div className="info-item w-100">
                                            <div className="info-icon"><FontAwesomeIcon icon={faCalendarCheck} /></div>
                                            <div className="info-content">
                                                <small>Fecha</small>
                                                <p>{citaData.fecha}</p>
                                            </div>
                                        </div>
                                        <div className="info-item w-100">
                                            <div className="info-icon"><FontAwesomeIcon icon={faClock} /></div>
                                            <div className="info-content">
                                                <small>Hora</small>
                                                <p>{citaData.hora}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="info-item px-2">
                                        <div className="info-icon"><FontAwesomeIcon icon={faEnvelope} /></div>
                                        <div className="info-content">
                                            <small>Correo</small>
                                            <p>{citaData.correo}</p>
                                        </div>
                                    </div>

                                    <div className="info-item">
                                        <div className="info-icon"><FontAwesomeIcon icon={faPhone} /></div>
                                        <div className="info-content">
                                            <small>Teléfono</small>
                                            <p>{citaData.telefono}</p>
                                        </div>
                                    </div>


                                    {citaData.observaciones && (
                                        <div className="info-item observaciones">
                                            <div className="info-icon mt-1"><FontAwesomeIcon icon={faInfoCircle} /></div>
                                            <div className="info-content">
                                                <small>Observaciones</small>
                                                <p>{citaData.observaciones}</p>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <div className="action-buttons my-3">
                                    <button className="bottom-custom-secondary" onClick={() => navigate('/')}>
                                        Volver al inicio
                                    </button>
                                    {!isCancelada && (
                                        <button className="bottom-custom" onClick={toggleCancelModal}>
                                            Cancelar Cita
                                        </button>
                                    )}
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <Modal isOpen={cancelModal} toggle={toggleCancelModal} centered className="modal-cancelacion">
                <ModalHeader toggle={toggleCancelModal} className="border-0 pb-0">
                    <h5 className="modal-title w-100 text-center text-danger font-weight-bold">¿Cancelar Cita?</h5>
                </ModalHeader>
                <ModalBody className="text-center pb-4 pt-4">
                    <div className="mb-4">
                        <FontAwesomeIcon icon={faBan} size="4x" className="text-danger" />
                    </div>
                    <p className="">¿Estás seguro que deseas cancelar tu cita para el <strong>{citaData?.fecha}</strong> a las <strong>{citaData?.hora}</strong>?</p>
                    <p className="text-muted small mt-3">Esta acción no se puede deshacer y liberará el espacio en la agenda.</p>
                </ModalBody>
                <ModalFooter className="border-0 pt-0 justify-content-center pb-4">
                    <button className="bottom-custom-secondary" onClick={toggleCancelModal} disabled={cancelando}>
                        No, mantener cita
                    </button>
                    <button className="bottom-custom mx-1" onClick={handleCancelarCita} disabled={cancelando}>
                        {cancelando ? <Spinner size="sm" /> : 'Sí, cancelar cita'}
                    </button>
                </ModalFooter>
            </Modal>
        </div>
    )
}

export default AgendateInfoCita